(function(root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.BCAComboCore = factory();
})(typeof globalThis !== 'undefined' ? globalThis : this, function() {
  'use strict';
  const normalize = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase();
  const variantId = value => Number(String(value || '').split('/').pop());
  function matches(product, catalog, target) {
    target = target || {};
    if (target.all_products) return true;
    const tests = [];
    if (target.product_types?.length) tests.push(target.product_types.some(t=>normalize(t)===normalize(product?.productType)));
    if (target.tags?.length) tests.push(target.tags.some(t=>(product?.tags||[]).some(v=>normalize(v)===normalize(t))));
    if (target.collection_handles?.length) tests.push(target.collection_handles.some(t=>(product?.collections||[]).some(v=>normalize(v.handle)===normalize(t))));
    if (target.product_handles?.length) tests.push(target.product_handles.some(t=>normalize(t)===normalize(product?.handle)));
    if (tests.length) return target.match==='all' ? tests.every(Boolean) : target.match==='minimum' ? tests.filter(Boolean).length >= Math.max(1,Math.min(4,Number(target.min_match)||2)) : tests.some(Boolean);
    const keyword = normalize(catalog?.keyword);
    return !!keyword && (normalize(product?.productType).includes(keyword) || !!catalog?.broad_match && (normalize(product?.title).includes(keyword) || (product?.tags||[]).some(t=>normalize(t).includes(keyword))));
  }
  function materialGroup(payload) {
    const settings = payload?.settings, options = settings?.product_options;
    if (!options?.enabled) return null;
    if (!options.system?.ready || options.system.mode !== 'nested-lines') throw Error('Consulta el material en la ficha antes de continuar.');
    const group = (options.groups || []).find(g=>g.enabled!==false && normalize(g.name)==='material' && matches(payload.product,settings.catalog,g.targeting_mode==='custom' ? g.targeting || options.targeting : options.targeting));
    return group ? {...group,values:(group.values||[]).filter(v=>v.enabled!==false)} : null;
  }
  function checkVariant(variant, label) {
    if (!variant || !Number.isSafeInteger(variantId(variant.id)) || variantId(variant.id)<=0) throw Error('Elige '+label+'.');
    if (variant.available !== true) throw Error('Esta opción ya no está disponible. Elige otra.');
    if (!Number.isSafeInteger(variant.price) || variant.price < 0) throw Error('No pudimos confirmar el precio. Abre la ficha del producto.');
  }
  function quote(shirt, blanket, material, charge) {
    checkVariant(shirt,'la talla de tu camiseta'); checkVariant(blanket,'el tamaño de tu cobija');
    let extra = 0;
    const surcharge = Number(material?.surcharge || 0);
    if (!Number.isFinite(surcharge) || surcharge < 0 || !Number.isSafeInteger(surcharge*100)) throw Error('No pudimos confirmar el material. Abre la ficha.');
    if (surcharge > 0) {
      checkVariant(charge,'un material disponible');
      if (variantId(material.chargeVariantId)!==variantId(charge.id) || charge.price!==surcharge*100) throw Error('El recargo del material necesita actualizarse. Elige otro material o consulta la ficha.');
      extra = charge.price;
    }
    return {shirt:shirt.price,blanket:blanket.price,extra,total:shirt.price+blanket.price+extra};
  }
  function buildItems(shirt,blanket,material,group,charge,token) {
    quote(shirt,blanket,material,charge);
    if (!token || !/^[a-zA-Z0-9-]{8,100}$/.test(token)) throw Error('Vuelve a abrir el combo.');
    const properties = {'Combo Bacanime':'Camiseta + cobija',_BCA_COMBO_TOKEN:token};
    const shirtProperties = {...properties};
    if (material && group) { shirtProperties[group.name]=material.name; shirtProperties._BCA_OPTION_IDS=group.id+'='+material.id; }
    const items = [{id:variantId(shirt.id),quantity:1,properties:shirtProperties},{id:variantId(blanket.id),quantity:1,properties:{...properties}}];
    if (Number(material?.surcharge||0)>0) {
      const optionToken = 'bca-'+token;
      shirtProperties._BCA_OPTIONS_TOKEN = optionToken;
      items.push({id:variantId(charge.id),quantity:1,parent_id:variantId(shirt.id),properties:{...properties,'Opción Bacanime':group.name+': '+material.name,_BCA_ADDON:'1',_BCA_PARENT_TOKEN:optionToken,_BCA_GROUP_ID:group.id,_BCA_VALUE_ID:material.id}});
    }
    return items;
  }
  function reconcile(cart,operation) {
    const actual = (cart?.items || []).filter(item=>item.properties?._BCA_COMBO_TOKEN===operation.token);
    if (!actual.length) return 'absent';
    const sums = new Map();
    actual.forEach(item=>{const id=variantId(item.variant_id||item.id);sums.set(id,(sums.get(id)||0)+Number(item.quantity||0));});
    const expected = new Map();
    operation.items.forEach(item=>expected.set(item.id,(expected.get(item.id)||0)+item.quantity));
    return sums.size===expected.size && [...expected].every(([id,qty])=>sums.get(id)===qty) ? 'complete' : 'partial';
  }
  return {normalize,variantId,matches,materialGroup,quote,buildItems,reconcile};
});